import React from 'react';

const clients = [
  { name: 'CNPC', fullName: 'China National Petroleum Corporation', icon: 'ri-oil-line' },
  { name: 'Sinopec', fullName: 'China Petroleum & Chemical Corporation', icon: 'ri-fire-line' },
  { name: 'CNOOC', fullName: 'China National Offshore Oil Corporation', icon: 'ri-ship-line' },
  { name: 'Yanchang', fullName: 'Shaanxi Yanchang Petroleum', icon: 'ri-building-4-line' },
];

export default function RixinClients() {
  return (
    <section className="bg-background-50 py-16 md:py-20 border-t border-background-200/60">
      <div className="w-full px-4 md:px-8 lg:px-16">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-12">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-4">
              <i className="ri-heart-line text-sm w-4 h-4 flex items-center justify-center" />
              Clientes Globales
            </div>
            <h2 className="font-heading text-xl md:text-3xl font-bold text-foreground-950 mb-3">
              Respaldado por las <span className="text-secondary-500">Grandes Petroleras de China</span>
            </h2>
            <p className="text-foreground-500 text-sm md:text-base max-w-2xl mx-auto">
              Los productos de Rixin Group han sido utilizados durante años por las principales 
              empresas petroleras de China, con excelentes resultados y reputación consolidada.
            </p>
          </div>

          <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
            {clients.map((client) => (
              <div
                key={client.name}
                className="bg-background-100 rounded-lg p-6 border border-background-200/60 text-center hover:border-secondary-300/60 transition-all duration-300"
              >
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-600 mx-auto mb-3">
                  <i className={`${client.icon} text-xl`} />
                </div>
                <h3 className="font-heading text-lg font-bold text-foreground-950 mb-1">{client.name}</h3>
                <p className="text-foreground-500 text-xs leading-relaxed">{client.fullName}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}